import { FC } from "react";
import { PlatformSettingForm } from "./PlatformSettingForm";

export const StaleOrdersSettings: FC = () => (
  <PlatformSettingForm
    name="stale_after_hours"
    title="Автоотмена заказов без исполнителя"
    label="Часов после назначенного времени *"
    placeholder="24"
    min={1}
    max={720}
    step={1}
    hint="Заказ, на который не нашёлся исполнитель, отменяется автоматически через указанное число часов после назначенного времени подачи; холд по карте клиента снимается, клиент получает уведомление. Такие заказы перестают рассылаться исполнителям. Проверка идёт раз в минуту, новое значение действует сразу."
  />
);
